import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getClientDeviceWidth } from '@client/redux/modules/clientDevice/selectors';
import { BREAK_POINT_SCREEN_SM } from '../../../../config/constants';

import RecommendationsCarousel from '../RecommendationsCarousel';
import RecommendationsCarouselMobile from '../RecommendationsCarouselMobile';
import LoadingCards from '../Loading';

export class Recommendations extends Component {
    static propTypes = {
        recommendations: PropTypes.array.isRequired,
        source: PropTypes.number,
        itemWidth: PropTypes.number,
        width: PropTypes.number.isRequired,
        deviceWidth: PropTypes.number.isRequired,
        trackByContainer: PropTypes.bool,
        newCardStyle: PropTypes.bool,
        showLoading: PropTypes.bool,
        onRecoClick: PropTypes.func,
        onSwipe: PropTypes.func
    }

    render() {
        const {
            recommendations,
            itemWidth,
            width,
            source,
            trackByContainer,
            deviceWidth,
            newCardStyle,
            showLoading,
            onRecoClick,
            onSwipe
        } = this.props;

        if (showLoading) {
            return <LoadingCards width={width} itemWidth={itemWidth} />;
        }

        if (!this.props.recommendations.length) {
            return null;
        }

        if (deviceWidth < BREAK_POINT_SCREEN_SM) {
            return (
                <RecommendationsCarouselMobile
                    recommendations={recommendations}
                    source={source}
                    trackByContainer={trackByContainer}
                    newCardStyle={newCardStyle}
                    onRecoClick={onRecoClick}
                    onSwipe={onSwipe}
                />
            );
        }

        return (
            <RecommendationsCarousel
                recommendations={recommendations}
                source={source}
                trackByContainer={trackByContainer}
                itemWidth={itemWidth}
                width={width}
                newCardStyle={newCardStyle}
                onRecoClick={onRecoClick}
                onSwipe={onSwipe}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    deviceWidth: getClientDeviceWidth(state)
});

export default connect(mapStateToProps, {})(Recommendations);
